export default "__VITE_ASSET__C_Ose_L___"